import React from 'react';
import { Col, Row, Label } from 'reactstrap';
import { api } from '../../../config';
import { convertToDisplayDateFormatddmmmyyyy } from '../../../utils/dateformatter';
import { useState, useEffect } from 'react';

const IncotermTableParcelFragment = ({ dataid, token }) => {
  const [qtyDeliveryDataIncoterm, setQtyDeliveryDataIncoterm] = useState({
    items: [],
  });

  useEffect(() => {
    const fetchDeliveryDataDetailIncoterm = async dataid => {
      // cek jika deliveryid belum tersedia
      try {
        const response = await fetch(
          `${api.API_URL}/quantity-incoterm?QuantityDeliveryTermId=${dataid}`,
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const result = await response.json();
        const items = result.data.items.map(item => ({
          incoterm: item.incoterm?.name ?? null,
          incotermPortType: item.incotermPortType,
          incotermLocation: item.incotermLocation?.name ?? null,
          startDate: convertToDisplayDateFormatddmmmyyyy(item.startDate),
          endDate: convertToDisplayDateFormatddmmmyyyy(item.endDate),
          incotermLocation2: item.incotermLocation2?.name ?? null,
          startDate2: convertToDisplayDateFormatddmmmyyyy(item.startDate2),
          endDate2: convertToDisplayDateFormatddmmmyyyy(item.endDate2),
          timelineType: item.timelineType,
        }));
        setQtyDeliveryDataIncoterm({ items });
      } catch (error) {
        console.error('Error:', error);
      }
    };

    fetchDeliveryDataDetailIncoterm(dataid);
  }, [dataid, token]);

  return (
    <Col lg={12}>
      <Label for='incotermreadonly' className='form-label'>
        Incoterm
      </Label>

      <Row>
        <Col sm={12} className='mt-2 overflow-x-auto'>
          <table className='table table-hover table-centered align-middle table-nowrap mb-2'>
            <thead className='text-muted table-light'>
              <tr>
                <th scope='col' width='10%'>
                  Delivery
                </th>
                <th scope='col' width='10%'>
                  Port Type
                </th>
                <th scope='col' width='10%'>
                  Port 1
                </th>
                <th scope='col' width='10%'>
                  Parcel Size 1
                </th>
                <th scope='col' width='10%'>
                  ALD/ADD
                </th>
                <th scope='col' width='10%'>
                  Alpha
                </th>
                <th scope='col' width='10%'>
                  Port 2
                </th>
                <th scope='col' width='10%'>
                  Parcel Size
                </th>
                <th scope='col' width='10%'>
                  ALD/ADD
                </th>
                <th scope='col' width='10%'>
                  Alpha
                </th>
              </tr>
            </thead>

            <tbody>
              {qtyDeliveryDataIncoterm.items.map((data, index) => (
                <tr key={`${data.id}-${index}`}>
                  <td>
                    <p className=' mb-1'>100 MB</p>
                  </td>
                  <td>
                    <p className=' mb-1'> {data.incotermPortType}</p>
                  </td>
                  <td>
                    <p className=' mb-1'>{data.incotermLocation}</p>
                  </td>
                  <td>
                    <p className=' mb-1'></p>
                  </td>
                  <td>
                    <p className=' mb-1'>{data.timelineType}</p>
                  </td>
                  <td>
                    <p className=' mb-1'></p>
                  </td>
                  <td>
                    <p className=' mb-1'>{data.incotermLocation2}</p>
                  </td>
                  <td>
                    <p className=' mb-1'></p>
                  </td>
                  <td>
                    <p className=' mb-1'></p>
                  </td>
                  <td>
                    <p className=' mb-1'></p>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </Col>
      </Row>
    </Col>
  );
};

export default IncotermTableParcelFragment;
